import { useCallback, useEffect, useRef, useState } from "react";
import api from "../api";

const usePaymentMethod = () => {
  const [data, setData] = useState(null);
  const hasFetched = useRef(false);

  const cb = useCallback(async () => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    try {
      const { data: response } = await api.get("/api/billing/card_info");
      setData(response?.card_info);
    } catch (error) {
      console.error("Failed to fetch billing data:", error);
    }
  }, []);

  useEffect(() => {
    cb();
  }, [cb]);

  return { data };
};

export default usePaymentMethod;
